export default {
  contact_provider: 'Contatta il tuo provider per attivare questa funzione.',
};
